import Modal from "react-bootstrap/Modal";
import clsx from "clsx";
import Styles from "./index.module.scss";
function AdminModal({ isShow, handleCloseModal, title, children }) {
  return (
    <Modal
      show={isShow}
      onHide={handleCloseModal}
      className={clsx(Styles.main)}
    >
      <Modal.Header className={clsx(Styles.headerWrap)}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={clsx(Styles.bodyWrap)}>{children}</Modal.Body>
      <Modal.Footer className={clsx(Styles.footerWrap)}></Modal.Footer>
    </Modal>
  );
}

export default AdminModal;
